import { render, staticRenderFns } from "./SupportTicketNew.vue?vue&type=template&id=357bc6b0&"
import script from "./SupportTicketNew.vue?vue&type=script&lang=js&"
export * from "./SupportTicketNew.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports